import { create } from 'zustand'

// import { SERVICE_REQUEST_ACTIVATION, SERVICE_REQUEST_STATUS_ACTIVE } from '@apps-common/config/service-request-filter'

type ServiceRequestType = 'activations' | 'monitoring-changes'

interface IServiceRequestFilterStore {
  type: ServiceRequestType
  setType: (type: ServiceRequestType) => void
  archived: boolean
  setArchived: (value: boolean) => void
}

export const useServiceRequestFilterStore = create<IServiceRequestFilterStore>((set) => ({
  type: 'activations',
  setType: (type: ServiceRequestType) => set(() => ({ type })),
  archived: false,
  setArchived: (value: boolean) => set(() => ({ archived: value }))
}))
